import React, { useEffect, useState } from 'react';
import Fuse from 'fuse.js';
import { GetEventQuery } from '../../../../graphql/queries/getEvent.generated';
import i18n from '@/utils/i18n';
import { Button, Table } from 'reactstrap';
import { ContentSection } from '../../../../components/Layout/ContentSection';
import CustomPagination from '../../../../components/CustomPagination';

const PAGE_SIZE = 5;

type SelectItemLocationEventAccountProps = {
  eventData: GetEventQuery | undefined;
  eventAccountId: string | null;
  setEventAccountId: (eventAccountId: string | null) => void;
  setItemLocationId: (itemLocationId: string | null) => void;
  setItemLocationName: (itemLocationId: string) => void;
  selectEventAccountTitle: string;
};

export const SelectItemLocationEventAccount = (
  props: SelectItemLocationEventAccountProps,
) => {
  const {
    eventData,
    eventAccountId,
    setEventAccountId,
    setItemLocationId,
    setItemLocationName,
    selectEventAccountTitle,
  } = props;
  const [page, setPage] = useState(1);
  const [searchTermEventAccounts, setSearchTermEventAccounts] = useState('');

  const { event_participants: eventParticipants } = eventData?.event || {};

  function getTitle(ogTitle: string, mustSelect: boolean) {
    let title = ogTitle;
    if (!mustSelect) {
      title += ' (' + i18n.t('Common:optional') + ')';
    }
    return title;
  }

  let fuseEventParticipants = eventParticipants;

  if (
    eventParticipants &&
    eventParticipants.length !== 0 &&
    searchTermEventAccounts.length > 0
  ) {
    const fuse = new Fuse(eventParticipants, {
      keys: ['name'],
    });

    fuseEventParticipants = fuse
      .search(searchTermEventAccounts)
      .map((result) => {
        return result.item;
      });
  }

  useEffect(() => {
    setPage(1);
  }, [searchTermEventAccounts]);

  const paginationResults = fuseEventParticipants?.length || 0;
  const pageCount = Math.ceil(paginationResults / PAGE_SIZE);

  const eventAccountName = eventParticipants?.find(
    (x) => x.id === eventAccountId,
  )?.name;
  const hasEventAccountName = eventAccountName != null;

  return (
    <ContentSection
      title={getTitle(selectEventAccountTitle, false)}
      collapsable={false}
    >
      {i18n.t('CreateOrderFulfillment:selectEventAccountDescription')}

      {hasEventAccountName && (
        <>
          <h3 className="mt-4 mb-4">
            {i18n.t('CreateOrderFulfillment:selected')}
          </h3>
          <b>
            <Button
              className="ms-3"
              color="primary"
              onClick={() => {
                setEventAccountId(null);

                setItemLocationId(null);
                setItemLocationName('');
              }}
            >
              {eventAccountName}
            </Button>
          </b>
        </>
      )}

      {!hasEventAccountName && (
        <>
          <h3 className="mt-4 mb-4">
            {i18n.t('CreateOrderFulfillment:selection')}
          </h3>
          <div className="input-group mb-3">
            <span className="input-group-text" id="basic-addon1">
              {i18n.t('Common:search')}
            </span>
            <input
              type="text"
              className="form-control"
              placeholder={i18n.t('Common:search')}
              value={searchTermEventAccounts}
              onChange={(e) => {
                setSearchTermEventAccounts(e.target.value);
              }}
            />
          </div>

          <Table striped bordered>
            <thead>
              <tr>
                <th>{i18n.t('Common:name')}</th>
              </tr>
            </thead>
            <tbody>
              {(typeof fuseEventParticipants === 'undefined' ||
                fuseEventParticipants?.length === 0) && (
                <tr>
                  <td>-</td>
                </tr>
              )}
              {fuseEventParticipants &&
                fuseEventParticipants
                  .slice(
                    (page - 1) * PAGE_SIZE,
                    (page - 1) * PAGE_SIZE + PAGE_SIZE,
                  )
                  .map(({ id, name }) => (
                    <tr key={id}>
                      <td>
                        <Button
                          className="ms-3"
                          key={id}
                          onClick={() => {
                            setEventAccountId(id);
                          }}
                          color={
                            id === eventAccountId ? 'primary' : 'secondary'
                          }
                        >
                          {name}
                        </Button>
                      </td>
                    </tr>
                  ))}
            </tbody>
          </Table>

          {paginationResults > PAGE_SIZE && (
            <CustomPagination
              pageCount={pageCount}
              currentPage={page}
              onPageChange={setPage}
            />
          )}
        </>
      )}
    </ContentSection>
  );
};
